import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: inherit;
	align-items: center;
	.motif-tab-navigation {
		flex: 1;
	}
`;
